import fire from "../../fire";

export default class FireRemoteService {
  public static correctAnswerExtraPopupFirstText: string =
    "correct_answer_extra_popup_first_text";
  public static correctAnswerExtraPopupFirstTitle: string =
    "correct_answer_extra_popup_first_title";
  public static correctAnswerExtraPopupSecondButton: string =
    "correct_answer_extra_popup_second_button";
  public static correctAnswerExtraPopupSecondText: string =
    "correct_answer_extra_popup_second_text";
  public static correctAnswerExtraPopupSecondTitle: string =
    "correct_answer_extra_popup_second_title";

  public static correctAnswerPopupButton: string =
    "correct_answer_popup_button";
  public static correctAnswerPopupMainTitle: string =
    "correct_answer_popup_main_title";
  public static correctAnswerPopupText: string = "correct_answer_popup_text";
  public static correctAnswerPopupTitle: string = "correct_answer_popup_title";

  public static noStampText: string = "no_stamp_text";
  public static noStampTitle: string = "no_stamp_title";

  public static oneStampLastDayText: string = "one_stamp_last_day_text";
  public static oneStampLastDayTitle: string = "one_stamp_last_day_title";

  public static oneStampText: string = "one_stamp_text";
  public static oneStampTitle: string = "one_stamp_title";

  public static twoStampLastDayText: string = "two_stamp_last_day_text";
  public static twoStampLastDayTitle: string = "two_stamp_last_day_title";

  public static twoStampText: string = "two_stamp_text";
  public static twoStampTitle: string = "two_stamp_title";

  public static wrongAnswerExtraPopupButton: string =
    "wrong_answer_extra_popup_button";
  public static wrongAnswerExtraPopupFirstText: string =
    "wrong_answer_extra_popup_first_text";
  public static wrongAnswerExtraPopupFirstTitle: string =
    "wrong_answer_extra_popup_first_title";
  public static wrongAnswerExtraPopupSecondText: string =
    "wrong_answer_extra_popup_second_text";
  public static wrongAnswerExtraPopupSecondTitle: string =
    "wrong_answer_extra_popup_second_title";

  public static wrongAnswerPopupButton: string = "wrong_answer_popup_button";
  public static wrongAnswerPopupMainTitle: string =
    "wrong_answer_popup_main_title";
  public static wrongAnswerPopupText: string = "wrong_answer_popup_text";
  public static wrongAnswerPopupTitle: string = "wrong_answer_popup_title";

  public static errorPopupTitle: string = "error_popup_title";
  public static errorPopupText: string = "error_popup_text";
  public static errorPopupButton: string = "error_popup_button";

  public static paymentFailMessageForCodeHeader: string =
    "payment_fail_message_for_code_header_";
  public static paymentFailMessageForCode: string =
    "payment_fail_message_for_code_";
  public static paymentErrorButton: string = "payment_error_button";

  public static wrong_answer_extra_reward_description: string =
    "wrong_answer_extra_reward_description";
  public static correct_answer_extra_reward_description: string =
    "correct_answer_extra_reward_description";
  public static correct_answer_description: string =
    "correct_answer_description";
  public static correct_answer_description_bayram: string =
    "correct_answer_description_bayram";
  public static wrong_answer_description: string = "wrong_answer_description";
  public static wrong_answer_description_bayram: string =
    "wrong_answer_description_bayram";
  public static wrong_answer_header: string = "wrong_answer_header";
  public static correct_answer_header: string = "correct_answer_header";
  public static new_question_button: string = "new_question_button";

  public static bayram_conditions_header: string = "bayram_conditions_header";
  public static bayram_conditions_desc: string = "bayram_conditions_desc";

  // Congratulations popup keys for correct answers
  public static correct_congratulations_popup_title: string =
    "correct_congratulations_popup_title";
  public static correct_congratulations_popup_fb: string =
    "correct_congratulations_popup_fb";
  public static correct_congratulations_popup_kazandin: string =
    "correct_congratulations_popup_kazandin";
  public static correct_congratulations_popup_info: string =
    "correct_congratulations_popup_info";
  public static correct_congratulations_popup_button: string =
    "correct_congratulations_popup_button";

  // Congratulations popup keys for wrong answers
  public static wrong_congratulations_popup_title: string =
    "wrong_congratulations_popup_title";
  public static wrong_congratulations_popup_fb: string =
    "wrong_congratulations_popup_fb";
  public static wrong_congratulations_popup_kazandin: string =
    "wrong_congratulations_popup_kazandin";
  public static wrong_congratulations_popup_info: string =
    "wrong_congratulations_popup_info";
  public static wrong_congratulations_popup_button: string =
    "wrong_congratulations_popup_button";

  // Answer modal keys for correct answers
  public static correct_popup_title: string = "correct_popup_title";
  public static correct_popup_fb: string = "correct_popup_fb";
  public static correct_popup_kazandin: string = "correct_popup_kazandin";
  public static correct_popup_info: string = "correct_popup_info";
  public static button_hemen_al: string = "button_hemen_al";
  public static correct_answer_enough_ply_button: string =
    "correct_answer_enough_ply_button";
  public static button_geri_don: string = "button_geri_don";

  // Answer modal keys for wrong answers
  public static wrong_popup_title: string = "wrong_popup_title";
  public static wrong_popup_fb: string = "wrong_popup_fb";
  public static wrong_popup_kazandin: string = "wrong_popup_kazandin";
  public static wrong_popup_info: string = "wrong_popup_info";

  // public static async init(): Promise<void> {
  //   await fire.remoteConfig().fetchAndActivate()
  //     .then(() => {
  //     })
  //     .catch((err) => {
  //     });
  // }

  // /**
  //  * When Safari first open, remoteConfig will crash the app (above logic)
  //  * remoteConfig.fetchTimeMillis will be negative if it fails.
  //  */
  // public static async init(): Promise<void> {
  //   const remoteConfig: firebase.remoteConfig.RemoteConfig = await fire.remoteConfig();
  //   if (remoteConfig.fetchTimeMillis > 0) {
  //     await remoteConfig.fetchAndActivate()
  //       .then(() => { })
  //       .catch((err) => { });
  //   }
  // }

  /**
   * When Safari first open, remoteConfig will crash and stops execution
   * Do not wait fetchAndActivate, dummy wait
   */
  public static async init(): Promise<void> {
    try {
      fire.remoteConfig().fetchAndActivate(); // safari blocks execution if it fails
      await new Promise((resolve) => setTimeout(resolve, 1000)); // dummy wait remote config
    } catch (e) {
      console.log("remoteConfig init fail");
    }
  }

  public static getStringValue(key: string): string {
    return fire.remoteConfig().getString(key);
  }
}
